export default [
  {
    label: 'DEBTIA_COUNTRIES_ANDORA-Andorra-Andorra',
    value: 1,
  },
  {
    label: 'DEBTIA_COUNTRIES_UAE-The United Arab Emirates-De Forenede Arabiske Emirater',
    value: 2,
  },
  {
    label: 'DEBTIA_COUNTRIES_AFG-Afghanistan-Afghanistan',
    value: 3,
  },
  {
    label: 'DEBTIA_COUNTRIES_ANTIGUE_AND_BARBUDA-Antigua and Barbuda-Antigua og Barbuda',
    value: 4,
  },
  {
    label: 'DEBTIA_COUNTRIES_ANGUILLA-Anguilla-Anguilla',
    value: 5,
  },
  {
    label: 'DEBTIA_COUNTRIES_ALBANIA-Albania-Albanien',
    value: 6,
  },
  {
    label: 'DEBTIA_COUNTRIES_ARMENIA-Armenia-Armenien',
    value: 7,
  },
  {
    label: 'DEBTIA_COUNTRIES_ANGOLA-Angola-Angola',
    value: 8,
  },
  {
    label: 'DEBTIA_COUNTRIES_ANTARTICA-Antarctica-Antarktis',
    value: 9,
  },
  {
    label: 'DEBTIA_COUNTRIES_ARGENTINA-Argentina-Argentina',
    value: 10,
  },
  {
    label: 'DEBTIA_COUNTRIES_SAMOA-Amerikansk Samoa-Amerikansk Samoa',
    value: 11,
  },
  {
    label: 'DEBTIA_COUNTRIES_AUSTRIA-Austria-Østrig',
    value: 12,
  },
  {
    label: 'DEBTIA_COUNTRIES_AUSTRALIA-Australia-Australien',
    value: 13,
  },
  {
    label: 'DEBTIA_COUNTRIES_ARUBA-Aruba-Aruba',
    value: 14,
  },
  {
    label: 'DEBTIA_COUNTRIES_AZERBAIJAN-Azerbaijan-Aserbajdsjan',
    value: 15,
  },
  {
    label: 'DEBTIA_COUNTRIES_BOSNIA-Bosnia Herzegovina-Bosnien-Hercegovina',
    value: 16,
  },
  {
    label: 'DEBTIA_COUNTRIES_BARBADOS-Barbados-Barbados',
    value: 17,
  },
  {
    label: 'DEBTIA_COUNTRIES_BANGLADESH-Bangladesh-Bangladesh',
    value: 18,
  },
  {
    label: 'DEBTIA_COUNTRIES_BELGIUM-Belgium-Belgien',
    value: 19,
  },
  {
    label: 'DEBTIA_COUNTRIES_BURKINA-Burkina Faso-Bourkina Faso',
    value: 20,
  },
  {
    label: 'DEBTIA_COUNTRIES_BULGARIA-Bulgaria-Bulgarien',
    value: 21,
  },
  {
    label: 'DEBTIA_COUNTRIES_BAHRAIN-Bahrain-Bahrain',
    value: 22,
  },
  {
    label: 'DEBTIA_COUNTRIES_BURUNDI-Burundi-Burundi',
    value: 23,
  },
  {
    label: 'DEBTIA_COUNTRIES_BENIN-Benin-Benin',
    value: 24,
  },
  {
    label: 'DEBTIA_COUNTRIES_SAINT-Saint Barthelmy-Saint Barthelmy',
    value: 25,
  },
  {
    label: 'DEBTIA_COUNTRIES_DEBTIA_COUNTRIES_TBI-The Bermuda Islands-Bermudaøerne',
    value: 26,
  },
  {
    label: 'DEBTIA_COUNTRIES_BURNEI-Burnei-Burnei',
    value: 27,
  },
  {
    label: 'DEBTIA_COUNTRIES_BOLIVIA-Bolivia-Bolivia',
    value: 28,
  },
  {
    label: 'DEBTIA_COUNTRIES_BONAIRE-Bonaire, Saint eusttius and Saba-Bonaire, Saint eusttius and Saba',
    value: 29,
  },
  {
    label: 'DEBTIA_COUNTRIES_BRAZIL-Brazil-Brasilien',
    value: 30,
  },
  {
    label: 'DEBTIA_COUNTRIES_BAHAMAS-Bahamas-Bahamaøerne',
    value: 31,
  },
  {
    label: 'DEBTIA_COUNTRIES_BHUTAN-Bhutan-Bhutan',
    value: 32,
  },
  {
    label: 'DEBTIA_COUNTRIES_BOUVET-Bouvet Island-Bouvetøen',
    value: 33,
  },
  {
    label: 'DEBTIA_COUNTRIES_BOTSWANA-Botswana-Botswana',
    value: 34,
  },
  {
    label: 'DEBTIA_COUNTRIES_HVIDERUSLAND-Belarus-Hviderusland',
    value: 35,
  },
  {
    label: 'DEBTIA_COUNTRIES_BELIZE-Belize-Belize',
    value: 36,
  },
  {
    label: 'DEBTIA_COUNTRIES_CANADA-Canada-Canada',
    value: 37,
  },
  {
    label: 'DEBTIA_COUNTRIES_COCOS-Cocos (Keeling) Islands-Cocosøerne (Keelingøerne)',
    value: 38,
  },
  {
    label: 'DEBTIA_COUNTRIES_CONGO-Congo Democratic Republic-Kongo Demokratisk Republik',
    value: 39,
  },
  {
    label: 'DEBTIA_COUNTRIES_CAR-Central African Republic-Den Centralafrikanske Republik',
    value: 40,
  },
  {
    label: 'DEBTIA_COUNTRIES_CONGO_REPUBLIC-Congo (Republic)-Congo (Republik)',
    value: 41,
  },
  {
    label: 'DEBTIA_COUNTRIES_SWITZERLAND-Switzerland-Schweiz',
    value: 42,
    en: '',
    da: '',
  },
  {
    label: 'DEBTIA_COUNTRIES_IVORY_COAST-Ivory Coast-Cote d\'Ivoire',
    value: 43,
  },
  {
    label: 'DEBTIA_COUNTRIES_THE_COOK_ISLANDS-The Cook Islands-Cookøerne',
    value: 44,
  },
  {
    label: 'DEBTIA_COUNTRIES_CHILE-Chile-Chile',
    value: 45,
  },
  {
    label: 'DEBTIA_COUNTRIES_CAMEROUN-Cameroun-Cameroun',
    value: 46,
  },
  {
    label: 'DEBTIA_COUNTRIES_CHINA-China-Kina',
    value: 47,
  },
  {
    label: 'DEBTIA_COUNTRIES_COLOMBIA-Colombia-Colombia',
    value: 48,
  },
  {
    label: 'DEBTIA_COUNTRIES_COSTA_RICA-Costa Rica-Costa Rica',
    value: 49,
  },
  {
    label: 'DEBTIA_COUNTRIES_DEBTIA_COUNTRIES_SAM-Serbia and Montenegro-Serbia OG Montenegro',
    value: 50,
  },
  {
    label: 'DEBTIA_COUNTRIES_CUBA-Cuba-Cuba',
    value: 51,
  },
  {
    label: 'DEBTIA_COUNTRIES_CAP_VERDE-Cap Verde-Cap Verde',
    value: 52,
  },
  {
    label: 'DEBTIA_COUNTRIES_CURACAO-Curacao-Curacao',
    value: 53,
  },
  {
    label: 'DEBTIA_COUNTRIES_CHRISTMAS_ISLAND-Christmas Island-Juleøen',
    value: 54,
  },
  {
    label: 'DEBTIA_COUNTRIES_CYPRUS-Cyprus-Cypern',
    value: 55,
  },
  {
    label: 'DEBTIA_COUNTRIES_CZECH_REPUBLIC-Czech Republic-Tjekkiet',
    value: 56,
  },
  {
    label: 'DEBTIA_COUNTRIES_GERMANY-Germany-Tyskland',
    value: 57,
  },
  {
    label: 'DEBTIA_COUNTRIES_DJIBOUTI-Djibouti-Djibouti',
    value: 58,
  },
  {
    label: 'DEBTIA_COUNTRIES_DOMINICA-The Dominican Republic-Den Dominikanske Republik',
    value: 59,
  },
  {
    label: 'DEBTIA_COUNTRIES_DDR-Agredfsfully-Aftalelidfdt',
    value: 60,
  },
  {
    label: 'DEBTIA_COUNTRIES_ALGERIA-Algeria-Algeriet',
    value: 61,
  },
  {
    label: 'DEBTIA_COUNTRIES_ECUADOR-Ecuador-Ecuador',
    value: 62,
  },
  {
    label: 'DEBTIA_COUNTRIES_ESTONIA-Estonia-Estland',
    value: 63,
  },
  {
    label: 'DEBTIA_COUNTRIES_EGYPT-Egypt-Egypten',
    value: 64,
  },
  {
    label: 'DEBTIA_COUNTRIES_WESTERN_SAHARA-Western Sahara-Vestsahara',
    value: 65,
  },
  {
    label: 'DEBTIA_COUNTRIES_ERITREA-Eritrea-Eritrea',
    value: 66,
  },
  {
    label: 'DEBTIA_COUNTRIES_SPAIN_EXCEPT-Spain (except XC, XL)-Spanien (undtagen XC, XL)',
    value: 67,
  },
  {
    label: 'DEBTIA_COUNTRIES_ETHIOPIA-Ethiopia-Etiopien',
    value: 68,
  },
  {
    label: 'DEBTIA_COUNTRIES_EU-EU-EU',
    value: 69,
  },
  {
    label: 'DEBTIA_COUNTRIES_FINLAND-Finland-Finland',
    value: 70,
  },
  {
    label: 'DEBTIA_COUNTRIES_FIJI-Fiji-Fiji',
    value: 71,
  },
  {
    label: 'DEBTIA_COUNTRIES_TFI-The Falkland Islands-Falklandøerne',
    value: 72,
  },
  {
    label: 'DEBTIA_COUNTRIES_SOMS-Smslt. of Micronesian States-Smslt. af Mikronesiske Stater',
    value: 73,
  },
  {
    label: 'DEBTIA_COUNTRIES_FAROE_ISLANDS-Faroe Islands-Færøerne',
    value: 74,
  },
  {
    label: 'DEBTIA_COUNTRIES_FRANCE-France-Frankrig',
    value: 75,
  },
  {
    label: 'DEBTIA_COUNTRIES_THE_MAINLAND_PLINTH-The mainland plinth-Fastlanssoklen',
    value: 76,
  },
  {
    label: 'DEBTIA_COUNTRIES_GABON-Gabon-Gabon',
    value: 77,
  },
  {
    label: 'DEBTIA_COUNTRIES_UK-United Kingdom-Storbritannien',
    value: 78,
  },
  {
    label: 'DEBTIA_COUNTRIES_GRENADA-Grenada-Grenada',
    value: 79,
  },
  {
    label: 'DEBTIA_COUNTRIES_GEORGIA-Georgia-Georgien',
    value: 80,
  },
  {
    label: 'DEBTIA_COUNTRIES_GHANA-Ghana-Ghana',
    value: 81,
  },
  {
    label: 'DEBTIA_COUNTRIES_GIBRALTAR-Gibraltar-Gibraltar',
    value: 82,
  },
  {
    label: 'DEBTIA_COUNTRIES_GREENLAND-Greenland-Grønland',
    value: 83,
  },
  {
    label: 'DEBTIA_COUNTRIES_GAMBIA-Gambia-Gambia',
    value: 84,
  },
  {
    label: 'DEBTIA_COUNTRIES_GUINEA-Guinea-Guinea',
    value: 85,
  },
  {
    label: 'DEBTIA_COUNTRIES_EQUATORIAL_GUINEA-Equatorial Guinea-Ækvatorialguinea',
    value: 86,
  },
  {
    label: 'DEBTIA_COUNTRIES_GREECE-Greece-Grækenland',
    value: 87,
  },
  {
    label: 'DEBTIA_COUNTRIES_SGTSS-South Georgia and the South Sandwic-South Georgia og De Sydlige Sandwic',
    value: 88,
  },
  {
    label: 'DEBTIA_COUNTRIES_GUATEMALA-Guatemala-Guatemala',
    value: 89,
  },
  {
    label: 'DEBTIA_COUNTRIES_GUAM-Guam-Guam',
    value: 90,
  },
  {
    label: 'DEBTIA_COUNTRIES_GUINEA_BISSAU-Guinea-Bissau-Guinea-Bissau',
    value: 91,
  },
  {
    label: 'DEBTIA_COUNTRIES_GUYANA-Guyana-Guyana',
    value: 92,
  },
  {
    label: 'DEBTIA_COUNTRIES_HONGKONG-Hongkong-Hongkong',
    value: 93,
  },
  {
    label: 'DEBTIA_COUNTRIES_HIMI-Heard Island and McDonald Islands-Heard Island og McDonald Islands',
    value: 94,
  },
  {
    label: 'DEBTIA_COUNTRIES_HONDURAS-Honduras-Honduras',
    value: 95,
  },
  {
    label: 'DEBTIA_COUNTRIES_CROATIA-Croatia-Kroatien',
    value: 96,
  },
  {
    label: 'DEBTIA_COUNTRIES_HAITI-Haiti-Haiti',
    value: 97,
  },
  {
    label: 'DEBTIA_COUNTRIES_HUNGARY-Hungary-Ungarn',
    value: 98,
  },
  {
    label: 'DEBTIA_COUNTRIES_INDONESIA-Indonesia-Indonesien',
    value: 99,
  },
  {
    label: 'DEBTIA_COUNTRIES_IRELAND-Ireland-Irland',
    value: 100,
  },
  {
    label: 'DEBTIA_COUNTRIES_ISRAEL-Israel-Israel',
    value: 101,
  },
  {
    label: 'DEBTIA_COUNTRIES_INDIA-India-Indien',
    value: 102,
  },
  {
    label: 'DEBTIA_COUNTRIES_BODIO-Brit. omr. in the Indian Ocean-Brit. omr. i Det indiske Ocean',
    value: 103,
  },
  {
    label: 'DEBTIA_COUNTRIES_IRAQ-Iraq-Iraq',
    value: 104,
  },
  {
    label: 'DEBTIA_COUNTRIES_IRAN-Iran-Iran',
    value: 105,
  },
  {
    label: 'DEBTIA_COUNTRIES_ISLAND-Island-Island',
    value: 106,
  },
  {
    label: 'DEBTIA_COUNTRIES_ITALY-Italy-Italien',
    value: 107,
  },
  {
    label: 'DEBTIA_COUNTRIES_JAMAICA-Jamaica-Jamaica',
    value: 108,
  },
  {
    label: 'DEBTIA_COUNTRIES_JORDAN-Jordan-Jordan',
    value: 109,
  },
  {
    label: 'DEBTIA_COUNTRIES_JAPAN-Japan-Japan',
    value: 110,
  },
  {
    label: 'DEBTIA_COUNTRIES_KENYA-Kenya-Kenya',
    value: 111,
  },
  {
    label: 'DEBTIA_COUNTRIES_KYRGYZSTAN-Kyrgyzstan-Kirgistan',
    value: 112,
  },
  {
    label: 'DEBTIA_COUNTRIES_CAMBODIA_KAMPUCHEA-Cambodia (Kampuchea)-Cambodia (Kampuchea)',
    value: 113,
  },
  {
    label: 'DEBTIA_COUNTRIES_KIRIBATI-Kiribati-Kiribati',
    value: 114,
  },
  {
    label: 'DEBTIA_COUNTRIES_COMOROS_EXCEPT-Comoros (except Mayotte)-Comorerne (undtagen Mayotte)',
    value: 115,
  },
  {
    label: 'DEBTIA_COUNTRIES_SCN-St. Christopher and Nevis-St. Christopher og Nevis',
    value: 116,
  },
  {
    label: 'DEBTIA_COUNTRIES_NORTH_KOREA-North Korea-Nordkorea',
    value: 117,
  },
  {
    label: 'DEBTIA_COUNTRIES_SOUTH_KOREA-South Korea-Sydkorea',
    value: 118,
  },
  {
    label: 'DEBTIA_COUNTRIES_KUWAIT-Kuwait-Kuwait',
    value: 119,
  },
  {
    label: 'DEBTIA_COUNTRIES_TCI-The Cayman Islands-Caymanøerne',
    value: 120,
  },
  {
    label: 'DEBTIA_COUNTRIES_KAZAKHSTAN-Kazakhstan-Kazakhstan',
    value: 121,
  },
  {
    label: 'DEBTIA_COUNTRIES_LAOS-Laos-Laos',
    value: 122,
  },
  {
    label: 'DEBTIA_COUNTRIES_LEBANON-Lebanon-Lebanon',
    value: 123,
  },
  {
    label: 'DEBTIA_COUNTRIES_ST_LUCIA-St. Lucia-St Lucia',
    value: 124,
  },
  {
    label: 'DEBTIA_COUNTRIES_LIECHTENSTEIN-Liechtenstein-Liechtenstein',
    value: 125,
  },
  {
    label: 'DEBTIA_COUNTRIES_SRI_LANKA-Sri Lanka-Sri Lanka',
    value: 126,
  },
  {
    label: 'DEBTIA_COUNTRIES_LIBERIA-Liberia-Liberia',
    value: 127,
  },
  {
    label: 'DEBTIA_COUNTRIES_LESOTHO-Lesotho-Lesotho',
    value: 128,
  },
  {
    label: 'DEBTIA_COUNTRIES_LITHUANIA-Lithuania-Litauen',
    value: 129,
  },
  {
    label: 'DEBTIA_COUNTRIES_LUXEMBOURG-Luxembourg-Luxembourg',
    value: 130,
  },
  {
    label: 'DEBTIA_COUNTRIES_LATVIA-Latvia-Letland',
    value: 131,
  },
  {
    label: 'DEBTIA_COUNTRIES_LIBYA-Libya-Libyen',
    value: 132,
  },
  {
    label: 'DEBTIA_COUNTRIES_MAROKKO-Marokko-Marokko',
    value: 133,
  },
  {
    label: 'DEBTIA_COUNTRIES_MOLDOVA-Moldova-Moldova',
    value: 134,
  },
  {
    label: 'DEBTIA_COUNTRIES_MONTENEGRO-Montenegro-Montenegro',
    value: 135,
  },
  {
    label: 'DEBTIA_COUNTRIES_MADAGASKAR-Madagaskar-Madagaskar',
    value: 136,
  },
  {
    label: 'DEBTIA_COUNTRIES_THE_MARSHALL_ISLANDS-The Marshall Islands-Marshalløerne',
    value: 137,
  },
  {
    label: 'DEBTIA_COUNTRIES_YUGOSLAV-Former Yugoslav Republic of-Den Tidligere Jugoslaviske Republik',
    value: 138,
  },
  {
    label: 'DEBTIA_COUNTRIES_MALI-Mali-Mali',
    value: 139,
  },
  {
    label: 'DEBTIA_COUNTRIES_MYANMAR-Myanmar-Myanmar',
    value: 140,
  },
  {
    label: 'DEBTIA_COUNTRIES_MONGOLIA-Mongolia-Mongoliet',
    value: 141,
  },
  {
    label: 'DEBTIA_COUNTRIES_MACAO-Macao-Macao',
    value: 142,
  },
  {
    label: 'DEBTIA_COUNTRIES_NORDMARIANERNE-The Northern Mariana Islands-Nordmarianerne',
    value: 143,
  },
  {
    label: 'DEBTIA_COUNTRIES_MAURITANIA-Mauritania-Mauretanien',
    value: 144,
  },
  {
    label: 'DEBTIA_COUNTRIES_MONTSERRAT-Montserrat-Montserrat',
    value: 145,
  },
  {
    label: 'DEBTIA_COUNTRIES_MALTA-Malta-Malta',
    value: 146,
  },
  {
    label: 'DEBTIA_COUNTRIES_MAURITIUS-Mauritius-Mauritius',
    value: 147,
  },
  {
    label: 'DEBTIA_COUNTRIES_MALDIVES-Maldives-Maldiverne',
    value: 148,
  },
  {
    label: 'DEBTIA_COUNTRIES_MALAWI-Malawi-Malawi',
    value: 149,
  },
  {
    label: 'DEBTIA_COUNTRIES_MEXICO-Mexico-Mexico',
    value: 150,
  },
  {
    label: 'DEBTIA_COUNTRIES_MALAYSIA-Malaysia-Malaysia',
    value: 151,
  },
  {
    label: 'DEBTIA_COUNTRIES_MOZAMBIQUE-Mozambique-Mozambique',
    value: 152,
  },
  {
    label: 'DEBTIA_COUNTRIES_NAMIBIA-Namibia-Namibia',
    value: 153,
  },
  {
    label: 'DEBTIA_COUNTRIES_CALEDONIA_AND_BELONGS-New Caledonia and belongs. omr-Ny Caledonien og tilhør. omr',
    value: 154,
  },
  {
    label: 'DEBTIA_COUNTRIES_NIGER-Niger-Niger',
    value: 155,
  },
  {
    label: 'DEBTIA_COUNTRIES_NORFOLK_ISLAND-Norfolk Island-Norfolk Island',
    value: 156,
  },
  {
    label: 'DEBTIA_COUNTRIES_NIGERIA-Nigeria-Nigeria',
    value: 157,
  },
  {
    label: 'DEBTIA_COUNTRIES_NICARAGUA-Nicaragua-Nicaragua',
    value: 158,
  },
  {
    label: 'DEBTIA_COUNTRIES_NEDERLANDENE-The Netherlands-Nederlandene',
    value: 159,
  },
  {
    label: 'DEBTIA_COUNTRIES_NORWAY-Norway-Norge',
    value: 160,
  },
  {
    label: 'DEBTIA_COUNTRIES_NEPAL-Nepal-Nepal',
    value: 161,
  },
  {
    label: 'DEBTIA_COUNTRIES_NAURU-Nauru-Nauru',
    value: 162,
  },
  {
    label: 'DEBTIA_COUNTRIES_NIUE-Niue-Niue',
    value: 163,
  },
  {
    label: 'DEBTIA_COUNTRIES_NEW_ZEALAND-New Zealand-New Zealand',
    value: 164,
  },
  {
    label: 'DEBTIA_COUNTRIES_OMAN-Oman-Oman',
    value: 165,
  },
  {
    label: 'DEBTIA_COUNTRIES_PANAMA-Panama-Panama',
    value: 166,
  },
  {
    label: 'DEBTIA_COUNTRIES_PERU-Peru-Peru',
    value: 167,
  },
  {
    label: 'DEBTIA_COUNTRIES_FRENCH_POYNESIA-French Poynesia-Fransk Poynesien',
    value: 168,
  },
  {
    label: 'DEBTIA_COUNTRIES_PAPUA_NEW_GUINEA-Papua New Guinea-Papua-Ny Guinea',
    value: 169,
  },
  {
    label: 'DEBTIA_COUNTRIES_PHILLIPINES-Phillipines-Filippinerne',
    value: 170,
  },
  {
    label: 'DEBTIA_COUNTRIES_PAKISTAN-Pakistan-Pakistan',
    value: 171,
  },
  {
    label: 'DEBTIA_COUNTRIES_POLAND-Poland-Polen',
    value: 172,
  },
  {
    label: 'DEBTIA_COUNTRIES_ST_PIERRE_OG_MIQUELON-St Pierre and Miquelon-St Pierre og Miquelon',
    value: 173,
  },
  {
    label: 'DEBTIA_COUNTRIES_THE_PITCAIRN_ISLANDS-The Pitcairn Islands-Pitcairnøerne',
    value: 174,
  },
  {
    label: 'DEBTIA_COUNTRIES_PALESTINE-The Occupied Palestinian Territory-Det besatte palæstinensiske område',
    value: 175,
  },
  {
    label: 'DEBTIA_COUNTRIES_PORTUGAL-Portugal-Portugal',
    value: 176,
  },
  {
    label: 'DEBTIA_COUNTRIES_PALAU-Palau-Palau',
    value: 177,
  },
  {
    label: 'DEBTIA_COUNTRIES_PARAGUAY-Paraguay-Paraguay',
    value: 178,
  },
  {
    label: 'DEBTIA_COUNTRIES_QATAR-Qatar-Qatar',
    value: 179,
  },
  {
    label: 'DEBTIA_COUNTRIES_ROMANIA-Romania-Rumænien',
    value: 180,
  },
  {
    label: 'DEBTIA_COUNTRIES_RUSSIA-Russia-Rusland',
    value: 181,
  },
  {
    label: 'DEBTIA_COUNTRIES_RWANEN-Rwanda-Rwanen',
    value: 182,
  },
  {
    label: 'DEBTIA_COUNTRIES_SAUDI_ARABIA-Saudi Arabia-Saudi Arabien',
    value: 183,
  },
  {
    label: 'DEBTIA_COUNTRIES_SOLOMON_ISLANDS-Solomon Islands-Salomon-øerne',
    value: 184,
  },
  {
    label: 'DEBTIA_COUNTRIES_SEYCHELLES-Seychelles and Belonging Areas-Seychellerne og tilhør.områder',
    value: 185,
  },
  {
    label: 'DEBTIA_COUNTRIES_SUDAN-Sudan-Sudan',
    value: 186,
  },
  {
    label: 'DEBTIA_COUNTRIES_SWEDEN-Sweden-Sverige',
    value: 187,
  },
  {
    label: 'DEBTIA_COUNTRIES_SINGAPORE-Singapore-Singapore',
    value: 188,
  },
  {
    label: 'DEBTIA_COUNTRIES_HELENA_AND_BELONGING-St Helena and belonging.areas-St Helena og tilhør.områder',
    value: 189,
  },
  {
    label: 'DEBTIA_COUNTRIES_SLOVENIA-Slovenia-Slovenien',
    value: 190,
  },
  {
    label: 'DEBTIA_COUNTRIES_SVALBARD-Svalbard-Svalbard',
    value: 191,
  },
  {
    label: 'DEBTIA_COUNTRIES_SLOVAKIET-Slovakiet-Slovakiet',
    value: 192,
  },
  {
    label: 'DEBTIA_COUNTRIES_SIERRA_LEONE-Sierra Leone-Sierra Leone',
    value: 193,
  },
  {
    label: 'DEBTIA_COUNTRIES_SAN_MARINO-San Marino-San Marino',
    value: 194,
  },
  {
    label: 'DEBTIA_COUNTRIES_SENEGAL-Senegal-Senegal',
    value: 195,
  },
  {
    label: 'DEBTIA_COUNTRIES_SOMALIA-Somalia-Somalia',
    value: 196,
  },
  {
    label: 'DEBTIA_COUNTRIES_SURINAME-Suriname-Suriname',
    value: 197,
  },
  {
    label: 'DEBTIA_COUNTRIES_SYDSUDAN-Sydsudan-Sydsudan',
    value: 198,
  },
  {
    label: 'DEBTIA_COUNTRIES_SAO_TOME-Sao Tome and Principe-Sao Tome og Principe',
    value: 199,
  },
  {
    label: 'DEBTIA_COUNTRIES_EL_SALVADOR-El Salvador-El Salvador',
    value: 200,
  },
  {
    label: 'DEBTIA_COUNTRIES_SYRIEN-Syrien-Syrien',
    value: 201,
  },
  {
    label: 'DEBTIA_COUNTRIES_SWAZILAND-Swaziland-Swaziland',
    value: 202,
  },
  {
    label: 'DEBTIA_COUNTRIES_SAINT_MARTEN-Saint Marten (the Dutch part)-Saint Marten (den hollandske del)',
    value: 203,
  },
  {
    label: 'DEBTIA_COUNTRIES_TURKS-Turks- og Caicosøerne-Turks- og Caicosøerne',
    value: 204,
  },
  {
    label: 'DEBTIA_COUNTRIES_TCHAD-TChad-TChad',
    value: 205,
  },
  {
    label: 'DEBTIA_COUNTRIES_FRENCH_POSSESSIONS-The French possessions in the south-De franske besiddelser i det sydlig',
    value: 206,
  },
  {
    label: 'DEBTIA_COUNTRIES_TOGO-Togo-Togo',
    value: 207,
  },
  {
    label: 'DEBTIA_COUNTRIES_THAILAND-Thailand-Thailand',
    value: 208,
  },
  {
    label: 'DEBTIA_COUNTRIES_TOKELAU-Tokelau-Tokelau',
    value: 209,
  },
  {
    label: 'DEBTIA_COUNTRIES_EAST_TIMOR-East Timor-Østtimor',
    value: 210,
  },
  {
    label: 'DEBTIA_COUNTRIES_TURKMENISTAN-Turkmenistan-Turkmenistan',
    value: 211,
  },
  {
    label: 'DEBTIA_COUNTRIES_TUNISIA-Tunisia-Tunesien',
    value: 212,
  },
  {
    label: 'DEBTIA_COUNTRIES_TONGA-Tonga-Tonga',
    value: 213,
  },
  {
    label: 'DEBTIA_COUNTRIES_TURKEY-Turkey-Tyrkiet',
    value: 214,
  },
  {
    label: 'DEBTIA_COUNTRIES_TRINIEND_TOBAGO-Triniend and Tobago-Trinidad og Tobago',
    value: 215,
  },
  {
    label: 'DEBTIA_COUNTRIES_TUVALU-Tuvalu-Tuvalu',
    value: 216,
  },
  {
    label: 'DEBTIA_COUNTRIES_TAIWAN-Taiwan-Taiwan',
    value: 217,
  },
  {
    label: 'DEBTIA_COUNTRIES_TANZANIA-Tanzania-Tanzania',
    value: 218,
  },
  {
    label: 'DEBTIA_COUNTRIES_UKRAINE-Ukraine-Ukraine',
    value: 219,
  },
  {
    label: 'DEBTIA_COUNTRIES_UGANDA-Uganda-Uganda',
    value: 220,
  },
  {
    label: 'DEBTIA_COUNTRIES_SMALL_ISLANDS_USA-Smaller islands far from the United States-Mindre øer fjernt fra USA',
    value: 221,
  },
  {
    label: 'DEBTIA_COUNTRIES_USA-The United States of America-Amerikas Forenede Stater',
    value: 222,
  },
  {
    label: 'DEBTIA_COUNTRIES_URUGUAY-Uruguay-Uruguay',
    value: 223,
  },
  {
    label: 'DEBTIA_COUNTRIES_UZBEKISTAN-Usbekistan-Usbekistan',
    value: 224,
  },
  {
    label: 'DEBTIA_COUNTRIES_VATICAN_CITY-Vatican City State-Vatikanstaten',
    value: 225,
  },
  {
    label: 'DEBTIA_COUNTRIES_ST_VINCENT-St Vincent-St Vincent',
    value: 226,
  },
  {
    label: 'DEBTIA_COUNTRIES_VENEZUELA-Venezuela-Venezuela',
    value: 227,
  },
  {
    label: 'DEBTIA_COUNTRIES_BRIT_VIRGIN_ISLANDS-The Brit. Virgin Islands-De Brit. Jomfruøer',
    value: 228,
  },
  {
    label: 'DEBTIA_COUNTRIES_US_VIRGIN_ISLANDS-The US Virgin Islands-De Amerikanske Jomfruøer',
    value: 229,
  },
  {
    label: 'DEBTIA_COUNTRIES_VIETNAM-Vietnam-Vietnam',
    value: 230,
  },
  {
    label: 'DEBTIA_COUNTRIES_VANUATU-Vanuatu-Vanuatu',
    value: 231,
  },
  {
    label: 'DEBTIA_COUNTRIES_WALLIS_FUTUNA-Wallis and Futuna-Wallis og Futuna',
    value: 232,
  },
  {
    label: 'DEBTIA_COUNTRIES_SAMOA-Samoa-Samoa',
    value: 233,
  },
  {
    label: 'DEBTIA_COUNTRIES_AM_OCEANIA-Am. Oceania-Am. Oceanien',
    value: 234,
  },
  {
    label: 'DEBTIA_COUNTRIES_CEUTA-Ceuta-Ceuta',
    value: 235,
  },
  {
    label: 'DEBTIA_COUNTRIES_KOSOVO-Kosovo-Kosovo',
    value: 236,
  },
  {
    label: 'DEBTIA_COUNTRIES_MELILLA-Melilla-Melilla',
    value: 237,
    en: '',
    da: '',
  },
  {
    label: 'DEBTIA_COUNTRIES_AUSTRALIAN_OCEANIA-Australian Oceania-Australsk Oceanien',
    value: 238,
  },
  {
    label: 'DEBTIA_COUNTRIES_WEST_GAZA_STRIP-West Bank / Gaza Strip-Vestbredden/Gazastriben',
    value: 239,
  },
  {
    label: 'DEBTIA_COUNTRIES_POLAR_AREAS-Polar areas-Polarområder',
    value: 240,
  },
  {
    label: 'DEBTIA_COUNTRIES_SERBIA-Serbia-Serbien',
    value: 241,
  },
  {
    label: 'DEBTIA_COUNTRIES_YAMEN-Yemen-Yemen',
    value: 242,
  },
  {
    label: 'DEBTIA_COUNTRIES_YUGOSLAVIA-Yugoslavia-Jugoslavien',
    value: 243,
  },
  {
    label: 'DEBTIA_COUNTRIES_SOUTH_AFRICA-South Africa-Sydafrika',
    value: 244,
  },
  {
    label: 'DEBTIA_COUNTRIES_ZAMBIA-Zambia-Zambia',
    value: 245,
  },
  {
    label: 'DEBTIA_COUNTRIES_ZIMBABWE-Zimbabwe-Zimbabwe',
    value: 246,
  },
  {
    label: 'DEBTIA_COUNTRIES_DENMARK-Danmark-Danmark',
    value: 247,
  },
]
